// eslint-disable-next-line no-use-before-define
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router';
import { RootStateType } from '../redux-store/reducers';

export type AuthRoutePropsType = {
  path: string;
  component: React.ComponentType<any>;
  isLoggedIn: boolean;
  exact?: boolean;
  role?: string;
  acceptedRoles?: string[];
};

function ProtectedRoute({
  component: Component,
  isLoggedIn,
  role = '',
  acceptedRoles,
  ...rest
}: // eslint-disable-next-line no-undef
AuthRoutePropsType): JSX.Element {
  const { token, arn_link } = useSelector((store: RootStateType) => store.preventLogoutReducer);
  const loggedOutRedirectURI =
    arn_link && token
      ? `?token=${token}&arn_link=${arn_link}`
      : token
      ? `?token=${token}`
      : arn_link
      ? `?arn_link=${arn_link}`
      : '';
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          acceptedRoles?.includes(role) ? (
            <Component {...rest} />
          ) : (
            <Route
              path="*"
              render={() => {
                return `You are not authorized to view this page`;
              }}
            />
          )
        ) : (
          <Redirect
            to={{
              pathname: '/investor-signup',
              search: loggedOutRedirectURI,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
export default connect(
  ({ auth }: RootStateType) => ({ isLoggedIn: !!auth.token, role: auth.role }),
  {}
)(ProtectedRoute);
